import { Approval, ApprovedElement, Protocol, Role, Signature } from "../../entities";
import { getAuthorRefForGateway, getAuthorRefFromGateway } from './ParsingUtils';
export default class ApprovalParser {
    static toGateway(approval, app) {
        return {
            Id: approval._id,
            ApprovalStage: approval.stage,
            ApprovedBy: getAuthorRefForGateway(approval.approver, app),
            ApprovalRole: app.get('localCache').getRoleById(approval.role._id).name,
            ApprovedWhen: approval.timestamp,
            ApprovedObjects: approval.protocols.map((approvedProtocol) => {
                return {
                    Digest: approvedProtocol.digest,
                    DigestMethod: approvedProtocol.digestMethod,
                    Ref: approvedProtocol.data._id,
                };
            }),
        };
    }
    static fromGateway(gatewayApproval, app, signature) {
        const protocols = gatewayApproval.ApprovedObjects.map((approvedObject) => {
            return new ApprovedElement({
                data: Protocol.createRef(approvedObject.Ref),
                digest: approvedObject.Digest,
                digestMethod: approvedObject.DigestMethod,
            });
        });
        let role = app.get('localCache').getRole('master');
        if (gatewayApproval.ApprovalRole) {
            switch (gatewayApproval.ApprovalRole) {
                case 'Chiefmate':
                    role = app.get('localCache').getRole('headOf_deckLogbook');
                    break;
                case 'Master':
                    break;
                default:
                    role = app.get('localCache').getRole(gatewayApproval.ApprovalRole);
                    break;
            }
        }
        let stage = 1;
        if (gatewayApproval.ApprovalStage) {
            stage = gatewayApproval.ApprovalStage;
        }
        else if (gatewayApproval.ApprovalRole === 'Chiefmate') {
            stage = 2;
        }
        const approval = new Approval({
            protocols,
            stage,
            role: Role.createRef(role._id),
            approver: getAuthorRefFromGateway(gatewayApproval.ApprovedBy, app),
        });
        if (signature &&
            gatewayApproval.SignInfo &&
            gatewayApproval.SignInfo.SignatureMethod &&
            gatewayApproval.SignInfo.KeyInfo &&
            gatewayApproval.SignInfo.KeyInfo.KeyName) {
            approval.signature = new Signature(signature, gatewayApproval.SignInfo.KeyInfo.KeyName, gatewayApproval.SignInfo.SignatureMethod);
        }
        Object.assign(approval, {
            _id: gatewayApproval.Id,
            timestamp: gatewayApproval.ApprovedWhen,
        });
        return approval;
    }
}
//# sourceMappingURL=ApprovalParser.js.map